import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import {
  editTemplateFailure,
  // ALL
  getTemplateListing as getTemplatesAction,
  setIndividualTemplateListing,
  setIndividualTemplateListingeError,
  setTemplateError,
  setTemplateListing,
} from "./action";
import {
  //
  TEMPLATE_ADD_SUBMIT,
  TEMPLATE_EDIT_SUBMIT,
  TEMPLATE_INDIVIDUAL_START_LISTING,
  //
  TEMPLATE_START_LISTING,
} from "./constants";

import { errorAlert, successAlert } from "../Alerts/actions";

// ALL TEMPLATE
export function* getTemplates({ payload = { cancelToken: null } }) {
  const { cancelToken, type_of_category, ...options } = payload;
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = QueryString.stringify(options);
  try {
    const { data } = yield call(
      api(token, cancelToken).get,
      `api/email-template`,
      { params: { type_of_category: type_of_category, ...options } }
    );
    const line = data.data.length;
    yield put(setTemplateListing(data));
  } catch (e) {
    yield put(setTemplateError());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching templates!"));
  }
}

// INDIVIDUAL TEMPLATE
export function* getTemplatesIndividual({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `api/email-template/${payload.templateId}`
    );
    yield put(setIndividualTemplateListing(data));
    yield put(successAlert("Template Loaded Successfully!"));
  } catch (e) {
    yield put(setIndividualTemplateListingeError());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Error while fetching template with that ID!"));
  }
}

// EDIT TEMPLATE
export function* editTemplate({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `api/email-template/edit/${payload.id}`,
      payload
    );
    // yield put(editTemplateSuccess(data));
    yield put(successAlert("Template Edited Successfully!"));
    yield put(getTemplatesAction());
  } catch (e) {
    yield put(editTemplateFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Error while editing template with that ID!"));
  }
}

// ADD TEMPLATE
export function* addTemplate({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `api/email-template/add`,
      payload
    );
    // yield put(editTemplateSuccess(data));
    yield put(successAlert("Template Added Successfully!"));
    yield put(getTemplatesAction());
  } catch (e) {
    yield put(editTemplateFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Error while adding template with that ID!"));
  }
}

// ALL
export function* getTemplatesFlow() {
  yield takeEvery(TEMPLATE_START_LISTING, getTemplates);
}

// INDIVIDUAL
export function* getTemplatesIndividualFlow() {
  yield takeEvery(TEMPLATE_INDIVIDUAL_START_LISTING, getTemplatesIndividual);
}

// EDIT
export function* editTemplateFlow() {
  yield takeEvery(TEMPLATE_EDIT_SUBMIT, editTemplate);
}

// EDIT
export function* addTemplateFlow() {
  yield takeEvery(TEMPLATE_ADD_SUBMIT, addTemplate);
}

export default function* EmailSaga() {
  yield all([
    getTemplatesIndividualFlow(),
    getTemplatesFlow(),
    editTemplateFlow(),
    addTemplateFlow(),
  ]);
}
